import { useNavigate } from 'react-router'

import { routes } from '@/app/routes'
import { OnboardingWizard } from '@/features/onboarding/OnboardingWizard'
import { useProfile } from '@/shared/api/queries'
import { Skeleton } from '@/shared/ui'

import './onboarding.css'

export function OnboardingPage() {
  const navigate = useNavigate()
  const { data, isPending } = useProfile()

  return (
    <main className="stage-screen">
      {isPending ? (
        <Skeleton variant="row" rows={4} title />
      ) : (
        <OnboardingWizard
          stored={data?.residence_country}
          onFinished={() => void navigate(routes.dashboard)}
        />
      )}
    </main>
  )
}
